/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useContext } from 'react';
import { Link } from 'react-router';

import getUrl from '@/routes/routes/helpers/getUrl';
import Avatar from '../../components/Avatar';
import HeaderMenuButton from '../../components/HeaderMenu/components/HeaderMenuButton';
import HeaderMenuNav from '../../components/HeaderMenu/components/HeaderMenuNav';
import HeaderMenuSearch from '../../components/HeaderMenu/components/HeaderMenuSearch';
import DiscoveryInput from './components/DiscoveryInput';
import Logo from '../../components/Logo';
import {
  hideAboveSM,
  hideBelowLG,
  srOnly,
} from '../../base-styles/mixins.module.css';
import {
  button,
  hiddenNav,
  mask,
  visibleNav,
} from '../../components/HeaderMenu/styles.module.css';
import { avatar as avatarStyle } from './styles.module.css';
import { logo } from '../../components/Header/LDTHeader/styles.module.css';
import DiscoveryContext from '../../contexts/discoveryContext/contextV2';

const HeaderMenu = ({
  categoriesVisible,
  className,
  hasUserCookie,
  navId,
  navVisible,
  onButtonClick,
  onCategoriesClick,
  onCategoriesMouseEnterOrLeave,
  onMaskClick,
  onMyEventsClick,
  onNavCloseClick,
  onNavLinkClick,
  onSearchLinkClick,
  onSearchCloseClick,
  profile,
  searchVisible,
  selectedLocale,
  userSelectedLocale,
  narrow,
}) => {
  const {
    filters: {
      location: { name: locationName },
    },
  } = useContext(DiscoveryContext);

  return (
    <>
      <div className={hideBelowLG}>
        <div className={srOnly}>Let’s Do This</div>
        <Link
          to={getUrl.homepage(selectedLocale)}
          className={logo}
          title="Let’s Do This"
        >
          <Logo />
        </Link>
      </div>

      <div className={className}>
        {searchVisible && (
          <div>
            <HeaderMenuSearch
              onSearchCloseClick={onSearchCloseClick}
              searchVisible={searchVisible}
            />
          </div>
        )}
        {navVisible && (
          <button type="button" className={mask} onClick={onMaskClick} />
        )}
        <HeaderMenuButton
          className={button}
          navId={navId}
          navVisible={navVisible}
          onClick={onButtonClick}
        />
        <HeaderMenuNav
          categoriesVisible={categoriesVisible}
          className={navVisible ? visibleNav : hiddenNav}
          id={navId}
          hasUserCookie={hasUserCookie}
          onCategoriesClick={onCategoriesClick}
          onCategoriesMouseEnterOrLeave={onCategoriesMouseEnterOrLeave}
          onLinkClick={onNavLinkClick}
          onCloseClick={onNavCloseClick}
          expanded={navVisible}
          onMyEventsClick={onMyEventsClick}
          onSearchLinkClick={onSearchLinkClick}
          profile={profile}
          selectedLocale={selectedLocale}
          userSelectedLocale={userSelectedLocale}
          narrow={narrow}
        />

        <DiscoveryInput
          onClick={onSearchLinkClick}
          locationName={locationName}
        />

        {profile && (
          <Link
            to={getUrl.privateProfile()}
            className={`${hideAboveSM} ${avatarStyle}`}
          >
            <Avatar user={profile} small trackingSource="header_menu" />
          </Link>
        )}
      </div>
    </>
  );
};

export default HeaderMenu;
